import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../../Context/LanguageContext";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import commonUtils from "../../../helpers/commonUtils";
import Pruef_PlanActions from "../../../Actions/Pruef_PlanActions";
import CreateDigitalChecklist from "./AddPruefPlan";
import pruefPlanStores from "../../../Stores/PruefPlanStore";
import pruef_PlanConstants from "../../../Constants/Pruef_PlanConstants";
import { useSelectedConfigActionContext } from "../../../Context/GlobalContext";
import { customizeFilter } from "../../FilterOptions/CustomizeFilter";
import { Stack, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

/*--------------New imports for table -------------------------------------------*/
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { _helper } from "../../GlobalFunction/dateHelper";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import ConfirmationPopUp from "../../MessageBox/ConfirmationPopUp";
import { PageHeader } from "../../MuiOverRideComponent/PageHeader";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid-pro";
import {
  LocalizationDataGridConst,
  tableFilterProperty,
} from "../../ReusableComponent/DataGrid/LocalizationDataGrid";
import RenderColDef, { RenderInnerTableColDef } from "./RenderColDef";
import CreateTemplate from "./createTemplate";
import AddChecklistPopUp from "./addChecklistModal";

/*--------------------------------------------------------------------------------*/
const DigitalCheckList = (props) => {
  const { data = {} } = props;
  const {
    equipmentGrpId,
    equipmentGrpName,
    setIsKostenstelleNew,
    setPruefPlanIdNew,
    setviewModeOnlyNew,
    setQuestionviewModeOnlyNew,
    setSndPruefDetailQuestionNew,
    setPruefplaneEqgrp,
    handleCompleted,
    setaddChecklistModalFlagFromWizard,
    setIsChecklistFromTemplateFromWizard,
    setIsCreateTemplateModalOpenFromWizard,
    setChecklistDataForTemplateFromWizard,
  } = data;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [egId, setEgId] = useState(0);
  const [egIdDetail, setEgIdDetail] = useState(0);
  const [pruefPlanId, setpruefPlanId] = useState("");
  const [equipmentGroupName, setequipmentGroupName] = useState("");
  const [isKostenstelle, setIsKostenstelle] = useState(false);
  const isKostenstelleFlagRef = useRef(null);
  const equipmentIdRef = useRef();
  const [viewModeOnly, setviewModeOnly] = useState(false);
  const updateSelectedConfig = useSelectedConfigActionContext();
  const [checkList, setCheckList] = useState([]);
  const [checkListDataGrid, setCheckListDataGrid] = useState(null);
  const [checkListDetails, setCheckListDetails] = useState("");
  const [originalCheckList, setOriginalChecklist] = useState([]);
  const [equipGrpListForFilter, setEquipGrpListForFilter] = useState([]);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [isCreateTemplateModalOpen, setIsCreateTemplateModalOpen] =
    useState(false);
  const [checklistDataForTemplate, setChecklistDataForTemplate] = useState("");
  const [addChecklistFlag, setAddChecklistFlag] = useState(false);
  const [addChecklistModalOpen, setAddChecklistModalOpen] = useState(false);
  const [isChecklistFromTemplate, setIsChecklistFromTemplate] = useState(false);

  function getCheckList() {
    setGlobalSpinner(true);
    Pruef_PlanActions.getChecklist();
  }

  useEffect(() => {
    if (!equipmentGrpId) {
      getCheckList();
    }

    function getCheckListSuccess() {
      const res = pruefPlanStores.getCheckListResult();
      if (res) {
        const columns = RenderColDef(localization, handleActionButtons);
        const rows = res.map((item) => ({
          ...item.highestVersionChecklist,
          highestVersionChecklist: item.highestVersionChecklist,
          allVersions: item.allVersions,
          werkId: item.plantId,
        }));
        setCheckListDataGrid({ rowData: rows, columns: columns });
      } else {
        setCheckList([]);
        setCheckListDataGrid(null);
        setOriginalChecklist([]);
      }
      setGlobalSpinner(false);
    }

    function getCheckListFailure() {
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_SUCCESS,
      getCheckListSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_FAILURE,
      getCheckListFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_SUCCESS,
        getCheckListSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_FAILURE,
        getCheckListFailure,
      );
    };
  }, []);

  function getCheckListDetails(id) {
    setGlobalSpinner(true);
    Pruef_PlanActions.getChecklistDetails(id);
  }

  useEffect(() => {
    function getCheckListDetailSuccess() {
      const res = pruefPlanStores.getCheckListDetails();
      if (res) {
        setCheckListDetails(res);
      } else {
        setCheckListDetails([]);
      }
      setGlobalSpinner(false);
    }
    function getCheckListDetailFailure() {
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS,
      getCheckListDetailSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE,
      getCheckListDetailFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_DETAILS_SUCCESS,
        getCheckListDetailSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_DETAILS_FAILURE,
        getCheckListDetailFailure,
      );
    };
  }, []);

  function publishChecklist(id) {
    setGlobalSpinner(true);
    Pruef_PlanActions.publishChecklist(id);
  }

  useEffect(() => {
    function getPublishCheckListSuccess() {
      const res = pruefPlanStores.getPublishCheckListResult();
      if (res) {
        toast.success(localization.checklistPublishSuccess);
        if (!equipmentGrpId) {
          getCheckList();
        } else {
          getCheklistForEquipmentGrp();
        }
      }
    }
    function getPublishCheckListFailure() {
      const res = pruefPlanStores.getPublishCheckListResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.PUBLISH_CHECKLIST_SUCCESS,
      getPublishCheckListSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.PUBLISH_CHECKLIST_FAILURE,
      getPublishCheckListFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.PUBLISH_CHECKLIST_SUCCESS,
        getPublishCheckListSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.PUBLISH_CHECKLIST_FAILURE,
        getPublishCheckListFailure,
      );
    };
  }, []);

  function getCheklistForEquipmentGrp() {
    setGlobalSpinner(true);
    Pruef_PlanActions.getChecklistByEquGrpId(equipmentGrpId);
  }

  useEffect(() => {
    if (equipmentGrpId) {
      getCheklistForEquipmentGrp();
    }
    return () => {};
  }, [equipmentGrpId]);

  useEffect(() => {
    function getCheckListForEqGrpSuccess() {
      const res = pruefPlanStores.getCheckListForEqGrpResult();
      setaddChecklistModalFlagFromWizard(false);
      if (res) {
        const columns = RenderColDef(localization, handleActionButtons);
        const rows = res.map((item) => ({
          ...item.highestVersionChecklist,
          highestVersionChecklist: item.highestVersionChecklist,
          allVersions: item.allVersions,
          werkId: item.plantId,
        }));
        setCheckListDataGrid({ rowData: rows, columns: columns });

        setOriginalChecklist(res);
      } else {
        setCheckListDataGrid(null);
        setCheckList([]);
        setOriginalChecklist([]);
      }
      if (equipmentGrpId) {
        EquipmentGroupActions.getSummaryEqGrp(equipmentGrpId);
      } else {
        setGlobalSpinner(false);
      }
      updateSelectedConfig("Test Plan");
    }
    function getCheckListForEqGrpFailure() {
      const res = pruefPlanStores.getCheckListForEqGrpResult();
      toast.error(res);
      setGlobalSpinner(false);
      updateSelectedConfig("Test Plan");
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_SUCCESS,
      getCheckListForEqGrpSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_FAILURE,
      getCheckListForEqGrpFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_SUCCESS,
        getCheckListForEqGrpSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.GET_CHECKLIST_FOR_EQ_GRP_FAILURE,
        getCheckListForEqGrpFailure,
      );
    };
  }, []);

  function deActivateChecklist(id) {
    setGlobalSpinner(true);
    Pruef_PlanActions.deActivateChecklist(id);
  }

  useEffect(() => {
    function deActivateCheckListSuccess() {
      const res = pruefPlanStores.getDeActivateChecklistResult();
      if (res) {
        toast.success(localization.checklistDeActivateSuccess);
        if (!equipmentGrpId) {
          getCheckList();
        } else {
          getCheklistForEquipmentGrp();
        }
      }
    }
    function deActivateCheckListFailure() {
      const res = pruefPlanStores.getDeActivateChecklistResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DEACTIVATE_CHECKLIST_SUCCESS,
      deActivateCheckListSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DEACTIVATE_CHECKLIST_FAILURE,
      deActivateCheckListFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DEACTIVATE_CHECKLIST_SUCCESS,
        deActivateCheckListSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DEACTIVATE_CHECKLIST_FAILURE,
        deActivateCheckListFailure,
      );
    };
  }, []);

  function deleteChecklist(id) {
    setGlobalSpinner(true);
    Pruef_PlanActions.deleteChecklist(id);
  }

  function deleteChecklistTemplate(idList) {
    setGlobalSpinner(true);
    Pruef_PlanActions.deleteChecklistTemplate(idList);
  }

  useEffect(() => {
    function deleteCheckListSuccess() {
      const res = pruefPlanStores.getDeleteChecklistResult();
      if (res) {
        toast.success(localization.checklistDeleteSuccess);
        if (!equipmentGrpId) {
          getCheckList();
        } else {
          getCheklistForEquipmentGrp();
        }
      }
    }
    function deleteCheckListFailure() {
      const res = pruefPlanStores.getDeleteChecklistResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_CHECKLIST_SUCCESS,
      deleteCheckListSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.DELETE_CHECKLIST_FAILURE,
      deleteCheckListFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_CHECKLIST_SUCCESS,
        deleteCheckListSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.DELETE_CHECKLIST_FAILURE,
        deleteCheckListFailure,
      );
    };
  }, []);

  function handleActionButtons(action, rowData) {
    switch (action) {
      case "view":
        getCheckListDetails(rowData.id);
        if (!equipmentGrpId) {
          setviewModeOnly(true);
        } else {
          setviewModeOnlyNew(true);
        }
        break;
      case "Edit":
        getCheckListDetails(rowData.id);
        if (!equipmentGrpId) {
          setviewModeOnly(false);
          setIsChecklistFromTemplate(false);
        } else {
          setviewModeOnlyNew(false);
          setIsChecklistFromTemplateFromWizard(false);
        }
        break;
      case "Publish":
        publishChecklist(rowData.id);
        break;
      case "Deactivate":
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.deactivateConfirmationMsg);
        setCallbackData({
          id: rowData.id,
        });
        setEventType("DEACTIVATE_CHECKLIST");
        break;
      case "Delete":
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.deleteConfirmation);
        setCallbackData({
          id: rowData.id,
        });
        setEventType("DELETE_CHECKLIST");
        break;
      case "SaveAsTemplate":
        if (!equipmentGrpId) {
          setIsCreateTemplateModalOpen(true);
          setIsChecklistFromTemplate(true);
          setChecklistDataForTemplate(rowData);
        } else {
          setIsCreateTemplateModalOpenFromWizard(true);
          setIsChecklistFromTemplateFromWizard(true);
          setChecklistDataForTemplateFromWizard(rowData);
        }
        break;
      case "DELETE_TEMPLATE":
        setConfirmationPopUpOpen(true);
        setConfirmationPopUpMsg(localization.deleteConfirmation);
        setCallbackData(rowData);
        setEventType("DELETE_TEMPLATE");
        break;
    }
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DEACTIVATE_CHECKLIST":
          deActivateChecklist(data.id);
          closePopUpCallback();
          break;
        case "DELETE_CHECKLIST":
          deleteChecklist(data.id);
          closePopUpCallback();
          break;
        case "DELETE_TEMPLATE":
          deleteChecklistTemplate(data);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  const handleAdd = () => {
    if (equipmentGrpId) {
      setIsKostenstelleNew(isKostenstelleFlagRef.current);
      setPruefPlanIdNew(0);
      setviewModeOnlyNew(false);
      setPruefplaneEqgrp(equipmentGrpId);
    }
    setIsKostenstelle(isKostenstelleFlagRef.current);
    setEgIdDetail(egId);
    equipmentIdRef.current = egId;
    setpruefPlanId(0);
    setviewModeOnly(false);
  };

  const saveAsTemplateCallback = (event) => {
    commonUtils.hideModalPopUp("addDigitalChecklistModalClose");
    setChecklistDataForTemplate("");
    setIsCreateTemplateModalOpen(false);
    setAddChecklistModalOpen(false);
  };
  function RenderAddPrufePlan() {
    return (
      <>
        <Button
          className="mr-4 cursorPoint svgIcon"
          id="addDigitalChecklistTest"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => {
            if (!equipmentGrpId) {
              setAddChecklistModalOpen(true);
            } else {
              setaddChecklistModalFlagFromWizard(true);
            }
          }}
        >
          {localization.addChecklist}
        </Button>
      </>
    );
  }

  const closePrufePlanEditPopUpCallback = () => {
    setEgIdDetail(0);
    setCheckListDetails("");
    setAddChecklistFlag(false);
  };

  useEffect(() => {
    function getEquipmentGroupSuccess() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();
      if (res && res.length > 0) {
        let sortList = res.sort((a, b) =>
          a.werk > b.werk ? 1 : a.werk < b.werk ? -1 : 0,
        );

        let tempArray = [];
        sortList.map((item) => {
          tempArray.push({
            name: item.bezeichnungsDisplay,
            value: item.bezeichnung,
          });
        });

        setEquipGrpListForFilter(tempArray);
      }
    }
    function getEquipmentGroupFailure() {
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
      getEquipmentGroupSuccess,
    );
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
      getEquipmentGroupFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
        getEquipmentGroupSuccess,
      );
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
        getEquipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    function addOrUpdateCheckListSuccess() {
      const res = pruefPlanStores.getAddorUpdatePruefPlanResult();
      if (res) {
        toast.success(localization.checklistSuccess);
        commonUtils.hideModalPopUp("addDigitalChecklistModalClose");
        if (!equipmentGrpId) {
          getCheckList();
        } else {
          getCheklistForEquipmentGrp();
        }
        setAddChecklistFlag(false);
      }
    }
    function addOrUpdateCheckListFailure() {
      const res = pruefPlanStores.getAddorUpdatePruefPlanResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefPlan_SUCCESS,
      addOrUpdateCheckListSuccess,
    );
    pruefPlanStores.addChangeListener(
      pruef_PlanConstants.ADDORUPDATE_PruefPlan_FAILURE,
      addOrUpdateCheckListFailure,
    );
    return () => {
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefPlan_SUCCESS,
        addOrUpdateCheckListSuccess,
      );
      pruefPlanStores.removeChangeListener(
        pruef_PlanConstants.ADDORUPDATE_PruefPlan_FAILURE,
        addOrUpdateCheckListFailure,
      );
    };
  }, []);

  const GridToolBarAction = [
    { label: "Add", component: <RenderAddPrufePlan />, onClick: handleAdd },
  ];
  const GridToolbarButton = () => (
    <>
      <div>
        {/* Title on the Left */}
        <div className="row w-100 ml-0 mr-0">
          <div className="col-4">
            <PageHeader Title={localization.digitalChecklistPageTitle} />
          </div>{" "}
          <div className="col d-flex justify-content-end">
            <GridToolbarQuickFilter
              style={{ marginLeft: "auto", width: "70%" }}
            />
          </div>
        </div>

        {/* Quick Filter on the Right */}
      </div>
      <GridToolbarContainer id="mainGridButton">
        <div>
          {" "}
          {<GridToolbarColumnsButton />}
          {<GridToolbarFilterButton />}
          {<GridToolbarDensitySelector />}
          {
            <GridToolbarExportContainer>
              <GridCsvExportMenuItem />
            </GridToolbarExportContainer>
          }
          {/* {gridFilter} */}
        </div>
        <div className="draftVersionIndicatorText">
          <span className="draftIconCls">*</span>
          {localization.draftVersionIndicatorText}
        </div>
        <div style={{ marginLeft: "auto" }} className="d-flex">
          {GridToolBarAction.map((action, index) => (
            <div key={index} onClick={action.onClick}>
              {action.component}
            </div>
          ))}
        </div>
      </GridToolbarContainer>
    </>
  );

  const GridToolbarInnerTableButton = () => (
    <GridToolbarContainer id="mainGridButton">
      <div>
        {<GridToolbarColumnsButton />}
        {<GridToolbarFilterButton />}
        {<GridToolbarDensitySelector />}
        {
          <GridToolbarExportContainer>
            <GridCsvExportMenuItem />
          </GridToolbarExportContainer>
        }
      </div>
    </GridToolbarContainer>
  );
  const DetailPanelContent = ({ row }) => {
    if (row?.allVersions?.length > 1) {
      const columnDefination = RenderInnerTableColDef(
        localization,
        handleActionButtons,
      );
      return (
        <Stack
          id="pruefPlanDetail"
          sx={{ boxSizing: "border-box" }}
          direction="column"
        >
          <Paper sx={{ flex: 1, mx: 1, width: "90%" }}>
            <Stack direction="column" spacing={1} sx={{ height: 1 }}>
              <Typography variant="h6">
                {localization.digitalCheckListVersion}
              </Typography>
              <DataGridPro
                density="compact"
                columns={columnDefination}
                slots={{ toolbar: GridToolbarInnerTableButton }}
                rows={row.allVersions}
                localeText={{
                  ...LocalizationDataGridConst(localization),
                }}
                slotProps={{
                  filterPanel: { ...tableFilterProperty },
                }}
              />
            </Stack>
          </Paper>
        </Stack>
      );
    }
  };

  const getDetailPanelHeight = React.useCallback((params) => {
    return "auto";
  }, []);

  return (
    <>
      <div
        style={{ height: "100%", width: "maxContent", overflow: "auto" }}
        id="content"
      >
        {checkListDataGrid && (
          <div
            id="dataGrid"
            className={equipmentGrpId ? "dataGridCheckList" : "dataGridLarge"}
          >
            <DataGridPro
              density="compact"
              rows={checkListDataGrid.rowData}
              columns={checkListDataGrid.columns}
              slots={{
                toolbar: GridToolbarButton,
                detailPanelExpandIcon: KeyboardArrowDownIcon,
                detailPanelCollapseIcon: KeyboardArrowUpIcon,
              }}
              getDetailPanelContent={DetailPanelContent}
              getDetailPanelHeight={getDetailPanelHeight}
              pagination
              localeText={{
                ...LocalizationDataGridConst(localization),
              }}
              slotProps={{
                pagination: {
                  labelRowsPerPage: localization.rowsPerPage,
                },
                filterPanel: { ...tableFilterProperty },
              }}
            />
          </div>
        )}
      </div>
      {!equipmentGrpId && (
        <CreateDigitalChecklist
          isKostenstelleFlag={isKostenstelle}
          equipmentGroupName={equipmentGroupName}
          pruefPlanId={pruefPlanId}
          egId={egIdDetail}
          closePrufePlanEditPopUpCallback={closePrufePlanEditPopUpCallback}
          viewModeOnly={viewModeOnly}
          checkListDetails={checkListDetails}
          addChecklistFlag={addChecklistFlag}
          getCheckListDetails={getCheckListDetails}
          isChecklistFromTemplate={isChecklistFromTemplate}
          setIsCreateTemplateModalOpen={setIsCreateTemplateModalOpen}
          setChecklistDataForTemplate={setChecklistDataForTemplate}
        />
      )}
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
      {!equipmentGrpId && isCreateTemplateModalOpen && (
        <CreateTemplate
          isCreateTemplateModalOpen={isCreateTemplateModalOpen}
          checklistDataForTemplate={checklistDataForTemplate}
          saveAsTemplateCallback={saveAsTemplateCallback}
        />
      )}
      {!equipmentGrpId && addChecklistModalOpen && (
        <AddChecklistPopUp
          setAddChecklistModalOpen={setAddChecklistModalOpen}
          getCheckListDetails={getCheckListDetails}
          setviewModeOnly={setviewModeOnly}
          setIsChecklistFromTemplate={setIsChecklistFromTemplate}
          handleActionButtons={handleActionButtons}
        />
      )}
    </>
  );
};

export default DigitalCheckList;
